import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _class;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { observer } from 'mobx-react';
import Modal from '../../../components/Modal';
import { Dialog, DialogContent, DialogButton, DialogFooter } from '../../../components/Dialog';
import { Form, Select, TextArea } from '../../../components/Form';
import styles from './InviteToTeamModal.m.sass';
import ContentLoading from '../../../components/ContentLoading';
import ContentError from '../../../components/ContentError';
var InviteToTeamModal = observer(_class = /*#__PURE__*/function (_React$Component) {
  function InviteToTeamModal() {
    _classCallCheck(this, InviteToTeamModal);
    return _callSuper(this, InviteToTeamModal, arguments);
  }
  _inherits(InviteToTeamModal, _React$Component);
  return _createClass(InviteToTeamModal, [{
    key: "render",
    value: function render() {
      var state = this.props.state;
      return /*#__PURE__*/React.createElement(Modal, {
        position: "top",
        isOpened: state.showing,
        onRequestClose: state.close
      }, /*#__PURE__*/React.createElement(InviteDialog, {
        state: state
      }));
    }
  }]);
}(React.Component)) || _class;
export { InviteToTeamModal as default };
var InviteDialog = observer(function InviteDialog(_ref) {
  var state = _ref.state;
  return /*#__PURE__*/React.createElement(Dialog, null, state.activate.match({
    pending: function pending() {
      return /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(ContentLoading, null));
    },
    rejected: function rejected(err) {
      return /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(ContentError, {
        error: err
      }));
    },
    resolved: function resolved() {
      return /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement("div", {
        className: styles.intro
      }, !state.invitationStore.rootStore.sessionStore.workspace.corporate && /*#__PURE__*/React.createElement("img", {
        className: styles.illustration,
        src: require('./illustration.svg'),
        alt: "Illustration of a group"
      }), /*#__PURE__*/React.createElement("p", {
        className: styles.title
      }, "Invite people to your team"), /*#__PURE__*/React.createElement("p", {
        className: styles.description
      }, "Let's get the ball rolling.")), /*#__PURE__*/React.createElement("div", {
        className: styles.form
      }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(TextArea, {
        className: "textarea",
        rows: 5,
        label: "Email address(es)",
        field: "email",
        model: state,
        help: "You can use comma- or newline-separated emails to invite multiple people."
      }), /*#__PURE__*/React.createElement(Select, {
        label: "Role",
        field: "teamRoleId",
        model: state,
        help: "When someone accepts the invitation, they are given this role."
      }, state.teamRoles.map(function (role) {
        return /*#__PURE__*/React.createElement("option", {
          key: role.id,
          value: role.id
        }, role.name);
      })), !state.target && /*#__PURE__*/React.createElement(Select, {
        label: "Portal",
        field: "target",
        model: state,
        help: "Which portal should the user be sent to?"
      }, /*#__PURE__*/React.createElement("option", {
        value: "CustomerPortal"
      }, "Customer Portal"), /*#__PURE__*/React.createElement("option", {
        value: "Portal"
      }, "Work Portal")))));
    }
  }), /*#__PURE__*/React.createElement(DialogFooter, {
    bordered: true
  }, /*#__PURE__*/React.createElement(DialogButton, {
    onClick: state.close
  }, "Close"), /*#__PURE__*/React.createElement(DialogButton, {
    type: "primary",
    onClick: state.sendInvite,
    disabled: state.activate.pending || state.sendInvite.pending || state.emailAddresses.length === 0,
    loading: state.sendInvite.pending
  }, formatButtonText(state.emailAddresses.length))));
});
function formatButtonText(count) {
  return count === 0 ? 'Send' : count === 1 ? 'Send Invite' : "Send ".concat(count, " Invites");
}
//# sourceMappingURL=index.js.map
